const GETUSERINFO = 'GETUSERINFO';
const UPDATEUSERRBAC = 'UPDATEUSERRBAC';

export {
  GETUSERINFO,
  UPDATEUSERRBAC,
};
